import options from './chart-proximity-advanced.component';

export default {
    selector: 'dtChartProximityAdvanced',
    options
};
